const getters = {
    // 代步车门店列表
    addressList: (state) => {
        return state.addressList;
    },
    // 用户权限
    scooterVip: (state) => {
        return state.scooterVip;
    }
}
export default getters